import i18next from 'i18next';

export const errorMessage = i18next.t('contact.errorMessage');
export const mandatoryFieldMessage = i18next.t('general.mandatoryField');
